import { kapixContext } from 'kapix-components-vue3'
import type { UserModule } from '~/types'

export const install: UserModule = async () => {
  kapixContext.UPLOADCARE_PUBLIC_KEY = import.meta.env.VITE_UPLOADCARE_PUBLIC_KEY
  kapixContext.GOOGLE_MAP_API_KEY = import.meta.env.VITE_GOOGLE_MAP_API_KEY
}

